import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { animateScroll as scroll } from 'react-scroll';
import * as styles from './topscroll.module.css'

export default class Topscroll extends Component {

  scrollToTop = () => {
    scroll.scrollToTop(); 
  }

  render() {
    return (
      <div className={styles.topscroll} onClick={this.scrollToTop} role='presentation'>
        <div>
          <FontAwesomeIcon icon={faArrowUp} />
        </div>
      </div>
    )
  }
}